/**
 * Created on 06/06/20.
 */
// 活动类别颜色列表
const activityTypeColors = [
  { name: '红色', code: 'color_01', show: true },
  { name: '橙色', code: 'color_02', show: true },
  { name: '黄色', code: 'color_03', show: true },
  { name: '绿色', code: 'color_04', show: true },
  { name: '蓝色', code: 'color_05', show: true }
]
export function getActivityTypeColors () {
  return activityTypeColors
}
export function getActivityTypeColorName (code) {
  let name = ''
  for (let i = 0; i < activityTypeColors.length; i++) {
    if (activityTypeColors[i].code === code) {
      name = activityTypeColors[i].name
      break
    }
  }
  return name
}

/**
 * @returns {Array}
 */
export function getInterviewStatus () {
  return [
    { key: 'wks', display_name: '未开始', color: 'primary' },
    { key: 'jxz', display_name: '进行中', color: 'success' },
    { key: 'yjs', display_name: '已结束', color: 'danger' }
  ]
}

export function getAuditStatus () {
  return [
    { key: 'AUDIT', display_name: '待审核', color: 'warning' },
    { key: 'ENABLE', display_name: '已通过', color: 'success' },
    { key: 'REJECT', display_name: '已拒绝', color: 'danger' }
  ]
}

/**
 * @returns {Array}
 */
export function getArriveStatus () {
  return [
    { key: 0, display_name: '未签到', color: 'danger', setFlag: 0 },
    { key: 1, display_name: '已签到', color: 'success', setFlag: 1 }
  ]
}

/**
 * @returns {Array}
 */
export function getCertStatus () {
  return [
    { key: 0, display_name: '未制证', color: 'danger' },
    { key: 1, display_name: '已制证', color: '' },
    { key: 2, display_name: '已领取', color: 'success' }
  ]
}

/**
 * 参会状态
 * @returns {Array}
 */
export function getJoinState () {
  return [
    { key: 0, display_name: '未邀请', color: 'danger', setFlag: 0 },
    { key: 1, display_name: '未确认', color: 'warning', setFlag: 0 },
    { key: 2, display_name: '确认参会', color: 'success', setFlag: 1 },
    { key: 99, display_name: '取消参会', color: 'info', setFlag: 1 }
  ]
}

/**
 * 制证状态
 * @returns {Array}
 */
export function getCertState () {
  return [
    { key: 0, display_name: '未制证', color: 'danger', setFlag: 0 },
    { key: 1, display_name: '已制证', color: '', setFlag: 1 },
    { key: 2, display_name: '已领取', color: 'success', setFlag: 1 }
  ]
}

/**
 * 抵达、离开票务状态
 * @returns {Array}
 */
export function getTicketState () {
  return [
    { key: 0, display_name: '未确认', color: 'danger', setFlag: 0 },
    { key: 1, display_name: '已确认', color: '', setFlag: 1 },
    { key: 2, display_name: '已出票', color: 'success', setFlag: 1 },
    { key: 3, display_name: '已改签', color: 'info', setFlag: 1 }
  ]
}

/**
 *  配置对象转换list tag 配置需求
 *
 * @param arr {Array}
 * @param keyName {String}
 * @param valName {String}
 * @returns {}
 */
export function getStatusObj (arr, keyName, valName) {
  const obj = {}
  try {
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (valName) {
          obj[arr[i][keyName]] = arr[i][valName]
        } else {
          obj[arr[i][keyName]] = arr[i]
        }
      }
    }
  } catch (e) {
    console.log(e.message)
  }
  return obj
}


/**
 *  配置对象转换list tag 配置需求
 *
 * @param arr {Array}
 * @param keyName {String}
 * @param valName {String}
 * @param valName1 {String}
 * @returns {}
 */
 export function getStatusObjTwo (fun, arr, keyName, valName, valName1) {
  const obj = {}
  try {
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (valName && valName1) {
          obj[arr[i][keyName]] = fun(arr[i][valName], arr[i][valName1])
        } else if (valName) {
          obj[arr[i][keyName]] = arr[i][valName]
        } else {
          obj[arr[i][keyName]] = arr[i]
        }
      }
    }
  } catch (e) {
    console.log(e.message)
  }
  return obj
}
